import './ErrorModal.scss';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useBoundAction } from 'src/hooks/useBoundAction';
import { Button } from 'src/modules/common/components/Button';
import { ModalBody } from 'src/modules/common/components/ModalBody';
import { ModalFooter } from 'src/modules/common/components/ModalFooter';
import { ModalHeader } from 'src/modules/common/components/ModalHeader';
import { ProjectTitle } from 'src/modules/common/components/ProjectTitle';
import { MODAL_PROJECT_ERROR_CLOSE, MODAL_PROJECT_ERROR_RETRY } from 'src/modules/modals/actions/ModalActions';
import { ModalWindowProjectError } from 'src/modules/modals/types/ModalWindow';

type Props = {
  readonly modal: ModalWindowProjectError;
};

export const ProjectErrorModal = ({ modal }: Props): React.ReactElement => {
  const intl = useIntl();
  const closeModal = useBoundAction(MODAL_PROJECT_ERROR_CLOSE.trigger, undefined);
  const saveProject = useBoundAction(MODAL_PROJECT_ERROR_RETRY.request, modal.data);

  const loading = modal.status?.state === 'pending';

  return (
    <div className="bp-error-modal">
      <ModalHeader
        title={<FormattedMessage id="projectErrorModal/title"/>}
      />

      <ModalBody>
        <div className="bp-error-modal__body">
          <h2 className="bp-error-modal__body-title">
            <FormattedMessage
              id="projectErrorModal/subtitle"
              values={{ project: <b><ProjectTitle title={modal.data.data.title}/></b> }}
            />
          </h2>

          <p className="bp-error-modal__body-description">
            <FormattedMessage id="projectErrorModal/description"/>
          </p>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          kind="secondary"
          fullWidth={true}
          onClick={closeModal}
          disabled={loading}
        >
          <FormattedMessage id="projectErrorModal/close"/>
        </Button>

        <Button
          disabled={loading}
          kind="primary"
          fullWidth={true}
          onClick={saveProject}
          autoFocus={true}
          loading={loading}
        >
          <FormattedMessage id="projectErrorModal/retry"/>
        </Button>
      </ModalFooter>
    </div>
  );
};
